import api from './api'

export default {
  revert(id) {
    return api.post(`/adoptions/${id}/revert`)
  },
}
